export const PEDIDO_STATUS = {
    AGUARDANDO: 1,
    RECEBIDO: 2,
    SEPARADO: 3,
    EM_TRANSPORTE: 4,
    FINALIZADO: 5,
    CANCELADO: 6,
    IMPORTANDO: 7,
    FATURADO: 8,
    DISPONIVEL_RETIRADA: 9,
    DISPONIVEL_RETIRADA_LOCKER: 10
};
